"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ArrowRight, Settings } from "lucide-react";
export default function HeroDelCatalogo() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="227030" id="introdução" className="relative w-full min-h-[85vh] flex items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/studio_minimalist_workspace.png)] bg-cover bg-center" />

      {}
      <div className="absolute inset-0 bg-background/95 mix-blend-normal" />
      <div className="absolute inset-0 bg-primary/5 mix-blend-overlay" />

      {}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: `linear-gradient(to right, rgba(0,0,0,0.1) 1px, transparent 1px), linear-gradient(to bottom, rgba(0,0,0,0.1) 1px, transparent 1px)`,
      backgroundSize: "40px 40px"
    }} />

      {}
      <div ref={ref} className={`relative z-10 flex flex-col items-center text-center px-4 md:px-8 max-w-5xl mx-auto transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        {}
        <div className="mb-6 inline-flex items-center justify-center p-3 bg-primary/10 rounded-full backdrop-blur-sm border border-primary/20">
          <Settings className="w-8 h-8 text-primary" />
        </div>

        {}
        <h1 className="font-default text-5xl md:text-[64px] font-bold text-foreground tracking-tighter leading-[1.1] mb-8">
          Fale com um especialista e entenda
          <br className="hidden md:block" /> como estruturar sua presença digital
        </h1>

        {}
        <div className="bg-transparent backdrop-blur-none border-none rounded-none p-6 md:p-8 mb-10 max-w-3xl shadow-none">
          <p className="text-muted-foreground text-lg md:text-xl font-default leading-relaxed">
            A ITC+ combina design estratégico e tecnologia de ponta para criar{" "}
            <strong className="text-foreground font-semibold">
              experiências digitais memoráveis
            </strong>{" "}
            que impulsionam o crescimento do seu negócio no mercado moderno.
          </p>
        </div>

        {}
        <Button asChild size="lg" className="rounded-full bg-primary text-primary-foreground shadow-lg hover:bg-primary/90 hover:shadow-primary/20 text-lg px-10 h-14 font-semibold transition-all hover:-translate-y-1 group">
          <Link to="/ContactPage">
            Começar Projeto
            <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" />
          </Link>
        </Button>
      </div>
    </section>;
}